import { useRouterState } from "@tanstack/react-router";

import { useAuth } from "@/context/auth";

export type Role = "worker" | "employer";

function isRole(x: unknown): x is Role {
  return x === "worker" || x === "employer";
}

/**
 * Returns the current role. Prefers the active route param from /app/$role/*,
 * falls back to the authenticated user's role if available.
 */
export function useRole(): Role {
  // Look for a match whose routeId is exactly "/app/$role"
  const roleFromRoute = useRouterState({
    select: (s) => {
      const match = s.matches.find((m) => m.routeId === "/app/$role");
      const r = match?.params.role;
      return isRole(r) ? r : undefined;
    },
  });

  const { user } = useAuth();
  const roleFromAuth = isRole(user?.role) ? user.role : undefined;

  return roleFromRoute ?? (roleFromAuth || 'worker');
}


